const GalleryData = [
    {
        id: 1,
        cover: require("../../Assets/Gallery/Gallery3.jpg"),
        alttag: "DLF The Crest",
    },
    {
        id: 2,
        cover: require("../../Assets/Gallery/gallery2.jpg"),
        alttag: "DLF The Crest",
    },
    {
        id: 3,
        cover: require("../../Assets/Gallery/gallery1.webp"),
        alttag: "DLF The Crest",
    },
    {
        id: 4,
        cover: require("../../Assets/Gallery/gallery4.jpg"),
        alttag: "DLF The Crest",
    },
    {
        id: 5,
        cover: require("../../Assets/Gallery/Gallery5.jpg"),
        alttag: "DLF The Crest",
    },
    {
        id: 6,
        cover: require("../../Assets/Gallery/Gallery6.jpg"),
        alttag: "DLF The Crest",
    },
   
]

export default GalleryData;